var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from "@angular/core";
import { Pagination, Table, TableData, TableDataTypes, } from "src/app/shared/types";
import { CaptainRedeemService } from "src/app/captain-redeem-service";
var CaptainGemsTransactionDetails = /** @class */ (function () {
    function CaptainGemsTransactionDetails(redeemService) {
        this.redeemService = redeemService;
        this.toggleHeaders = new EventEmitter();
        this.dataLoaded = false;
        this.perPage = 10;
        this.pageNo = 0;
        this.previousPageIndex = 0;
        this.lastDebitRequestId = "";
        this.lastCreditRequestId = "";
        this.priorDebitRequestId = "";
        this.priorCreditRequestId = "";
        this.transactionTypes = ["credit", "debit"];
        this.transactionArray = [];
        this.currentTransactionArray = [];
    }
    CaptainGemsTransactionDetails.prototype.ngOnInit = function () {
        this.declareTable();
    };
    CaptainGemsTransactionDetails.prototype.declareTable = function () {
        var _this = this;
        this.captainGemTransactions = new Table({
            toggleableHeaders: this.captainDetailsToggleableHeaders,
            headers: {
                OrderId: "Order Id",
                TransactionId: "Transaction Id",
                TransactionType: "Transaction Type",
                TransactionDate: "Transaction Date",
                GemCount: "Gem Count",
                RedeemType: "Reedeem Type",
                RedeemValue: "Redeem Value",
            },
            pagination: new Pagination(0, this.perPage, 200, [10], 0, true),
            selectedHeader: 12,
            defaultError: "No gem transactions found",
            onRefresh: function () {
                _this.captainGemTransactions = null;
                _this.ngOnInit();
            },
            data: [],
        });
        this.getGemTransactions();
    };
    CaptainGemsTransactionDetails.prototype.getNextGemTransactions = function (transactionArray) {
        this.priorCreditRequestId = "";
        this.priorDebitRequestId = "";
        for (var i = 0; i < transactionArray.length; i++) {
            var _a = transactionArray[i], id = _a.id, type = _a.type;
            if (type === "credit") {
                this.lastCreditRequestId = id;
            }
            if (type === "debit") {
                this.lastDebitRequestId = id;
            }
        }
    };
    CaptainGemsTransactionDetails.prototype.getGemTransactions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, startIdx, endIdx, reachedEnd, response, responseArray;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = {
                            filters: {
                                type: this.transactionTypes,
                            },
                            meta: {
                                count: this.perPage,
                                lastDebitRequestId: this.lastDebitRequestId,
                                lastCreditRequestId: this.lastCreditRequestId,
                                priorDebitRequestId: this.priorDebitRequestId,
                                priorCreditRequestId: this.priorCreditRequestId,
                            },
                        };
                        this.dataLoaded = false;
                        startIdx = this.pageNo * this.perPage;
                        endIdx = startIdx + this.perPage;
                        this.currentTransactionArray = this.transactionArray.slice(startIdx, endIdx);
                        reachedEnd = false;
                        if (!(this.currentTransactionArray.length == 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.redeemService.getCoinIncentivePassbookDetails(this.captainId, data)];
                    case 1:
                        response = _b.sent();
                        responseArray = response && response.data && response.data.data;
                        (_a = this.transactionArray).push.apply(_a, responseArray);
                        this.currentTransactionArray = responseArray;
                        if (this.currentTransactionArray.length == 0) {
                            reachedEnd = true;
                        }
                        _b.label = 2;
                    case 2:
                        if (!reachedEnd) {
                            this.setCaptainGemsTxnData();
                        }
                        else {
                            this.dataLoaded = true;
                            this.captainGemTransactions.pagination = new Pagination(this.pageNo - 1, this.perPage, this.transactionArray.length, [10], this.previousPageIndex - 1, true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CaptainGemsTransactionDetails.prototype.dateString = function (epoch) {
        return new Date(epoch * 1000).toLocaleString();
    };
    CaptainGemsTransactionDetails.prototype.createTableData = function (value, className, type, flag, hoverData) {
        if (flag === void 0) { flag = false; }
        if (hoverData === void 0) { hoverData = null; }
        return new TableData({
            data: value,
            type: type ? type : TableDataTypes.DATA,
            flag: flag,
            hoverData: hoverData,
            className: className
                ? className + " cursor-pointer"
                : "cursor-pointer whiteSpacePre",
        });
    };
    CaptainGemsTransactionDetails.prototype.changeInHeader = function (header) {
        this.toggleHeaders.emit(header);
    };
    CaptainGemsTransactionDetails.prototype.onPaginationChange = function (event) {
        this.perPage = event.perPage;
        this.pageNo = event.pageNo;
        this.previousPageIndex = event.previousPageIndex;
        if (this.pageNo < this.previousPageIndex) {
            var startIdx = this.pageNo * this.perPage;
            var endIdx = startIdx + this.perPage;
            this.currentTransactionArray = this.transactionArray.slice(startIdx, endIdx);
            this.setCaptainGemsTxnData();
        }
        else if (this.pageNo >= this.previousPageIndex) {
            this.getNextGemTransactions(this.currentTransactionArray);
            this.getGemTransactions();
        }
    };
    CaptainGemsTransactionDetails.prototype.setCaptainGemsTxnData = function () {
        var _this = this;
        this.captainGemTransactions.data = this.currentTransactionArray.map(function (transaction) {
            return {
                OrderId: _this.createTableData(transaction &&
                    transaction.orderDetails &&
                    transaction.orderDetails.id),
                TransactionId: _this.createTableData(transaction.id),
                TransactionType: _this.createTableData(transaction.type),
                TransactionDate: _this.createTableData(transaction.createdAt),
                GemCount: _this.createTableData(transaction.coin),
                RedeemType: _this.createTableData(transaction.rewardType),
                RedeemValue: _this.createTableData(transaction.amount),
            };
        });
        this.dataLoaded = true;
    };
    return CaptainGemsTransactionDetails;
}());
export { CaptainGemsTransactionDetails };
